const convertToExpireDate = (
  publishedDate: string | Date | null,
  daysToAdd: number = 90,
): Date | null => {
  // Handle null/undefined input
  if (!publishedDate) return null;

  try {
    // Create Date object from input (handles both string and Date)
    const published =
      publishedDate instanceof Date ? publishedDate : new Date(publishedDate);

    // Check if the date is valid
    if (isNaN(published.getTime())) {
      console.error('Invalid date provided:', publishedDate);
      return null;
    }

    // Create a copy to avoid mutating the original date
    const expiryDate = new Date(published);

    // Add the specified number of days
    expiryDate.setDate(expiryDate.getDate() + daysToAdd);

    return expiryDate;
  } catch (error) {
    console.error('Error calculating expiry date:', error);
    return null;
  }
};

export default convertToExpireDate;
